module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADMSURBVHgBdZC7EcIwEET3ThRACS4BInCoiE8EHUAHUAFQAUMFlAAZAwRmIPAwNOESTG7fITF8jAdfpNGu3mqPUDHHy22WZ/mdysIuigPDZgNoQ0UWtaK4j64DZqwVikww7Ntwyx/k+bokxkZASS7S7NvW1t9TESmiq65tT4rUmjE0g2rgXtmeDU/lPzGB6v5ggOBfG85ymSqQgnntq5UN9G0Qz4nZG5JXXPIkvA0dG86dMFYfxxwdonj0Qyguip3BCYFrNSVUjI9UUPoAU1xYLi1Ht1YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 0